import { schema } from 'normalizr'

export const creditCardSchema = new schema.Entity('creditCards', undefined, {
    processStrategy: value => {
        const { cardLast4 } = value
        return {
            lastFour: cardLast4.slice(-4),
            ...value,
        }
    },
})
export const vehicleSchema = new schema.Entity('vehicles')
export const couponSchema = new schema.Entity('coupons', undefined, {
    idAttribute: value => value.couponCode,
})

const handleEmpty = value => value || ''

export const userSchema = new schema.Entity(
    'users',
    {
        creditCards: [creditCardSchema],
        vehicles: [vehicleSchema],
        coupons: [couponSchema],
    },
    {
        idAttribute: 'emailAddress',
        processStrategy: value => {
            const {
                emailAddress: email,
                loginName: name,
                accountCardDetail: creditCards,
                parkingIndividualDetail: {
                    id,
                    salutation,
                    firstName,
                    lastName,
                    address1,
                    address2,
                    city,
                    state,
                    phone,
                    postalCode,
                    country,
                    emailAddress,
                    onDemandOptIn,
                    billingFirstName,
                    billingLastName,
                    billingAddress1,
                    billingAddress2,
                    billingCity,
                    billingState,
                    billingPostalCode,
                    billingCountry,
                    billingDistrict,
                    billingNumber,
                    deliveryName,
                    deliveryAddress: deliveryAddress1,
                    deliveryAddress2,
                    deliveryCity,
                    deliveryState,
                    deliveryPostCode: deliveryPostalCode,
                    deliveryCountry,
                    deliveryDistrict,
                    deliveryNumber,
                    vehicleDetail: vehicles,
                    custom1,
                    custom2,
                    customerDocumentNumber: documentNumber,
                    customerDocumentType: documentType,
                },
                accountCoupons: coupons,
                token,
                excludeFields,
                accountKey,
            } = value

            return {
                id: emailAddress,
                email: handleEmpty(email),
                name: handleEmpty(name),
                accountKey: handleEmpty(accountKey),
                accountId: id,
                creditCards,
                vehicles,
                coupons,
                token,
                onDemandOptIn,
                details: {
                    salutation: handleEmpty(salutation),
                    firstName: handleEmpty(firstName),
                    lastName: handleEmpty(lastName),
                    phone: handleEmpty(phone),
                    emailAddress: handleEmpty(emailAddress),
                    address: {
                        address1: handleEmpty(address1),
                        address2: handleEmpty(address2),
                        city: handleEmpty(city),
                        state: handleEmpty(state),
                        postalCode: handleEmpty(postalCode).toUpperCase(),
                        country: handleEmpty(country),
                    },
                    billingAddress: {
                        firstName: handleEmpty(billingFirstName),
                        lastName: handleEmpty(billingLastName),
                        address1: handleEmpty(billingAddress1),
                        address2: handleEmpty(billingAddress2),
                        city: handleEmpty(billingCity),
                        state: handleEmpty(billingState),
                        postalCode: handleEmpty(billingPostalCode).toUpperCase(),
                        country: handleEmpty(billingCountry),
                        district: handleEmpty(billingDistrict),
                        streetNumber: handleEmpty(billingNumber),
                    },
                    deliveryAddress: {
                        firstName: handleEmpty(deliveryName),
                        lastName: '',
                        address1: handleEmpty(deliveryAddress1),
                        address2: handleEmpty(deliveryAddress2),
                        city: handleEmpty(deliveryCity),
                        state: handleEmpty(deliveryState),
                        postalCode: handleEmpty(deliveryPostalCode).toUpperCase(),
                        country: handleEmpty(deliveryCountry),
                        district: handleEmpty(deliveryDistrict),
                        streetNumber: handleEmpty(deliveryNumber),
                    },
                    document: {
                        type: documentType,
                        number: documentNumber,
                    },
                    custom1,
                    custom2,
                    excludeFields,
                },
            }
        },
    }
)
